// //开发环境
let hsdApi = "https://myteacherapi.smartstudy.tw"    //TW-api
//let hsdApi = "http://127.0.0.1:8010"

export { hsdApi }